import {create} from 'zustand';
 
interface UserDetailsState {
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  notificationMode: string[];
  registerDate: string;
  setUserDetails: (details: Partial<UserDetailsState>) => void;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setMobile: (mobile: string) => void;
  setEmail: (email: string) => void;
  clearUserDetails: () => void;
}
 
const useUserDetailsStore = create<UserDetailsState>((set) => ({
  email: '',
  firstName: '',
  lastName: '',
  mobile: '',
  notificationMode: [],
  registerDate: '',
 
  setUserDetails: (details) =>
    set((state) => ({
      ...state,
      ...details,
    })),
 
  setFirstName: (firstName) =>
    set(() => ({
      firstName,
    })),
 
  setLastName: (lastName) =>
    set(() => ({
      lastName,
    })),
    setMobile: (mobile) =>
      set(() => ({
        mobile,
      })),
 
    setEmail: (email) =>
      set(() => ({
        email,
      })),
 
  clearUserDetails: () =>
    set(() => ({
      email: '',
      firstName: '',
      lastName: '',
      mobile: '',
      notificationMode: [],
      registerDate: '',
    })),
}));
 
export default useUserDetailsStore;
 